import React from "react";
import { FeedbackDeal } from "@/components";
import { useModal } from "@/store";
import { Popover } from "antd";
import dealProcessPng from "./images/deal_process.png";
import "./style.less";
import { useMemo } from "react";

function DealBtn({className = "", contacts, contacts_tel}) {

    const content = useMemo(() => (
        <div>
            <p>联系人：{contacts}</p>
            <p>联系电话：{contacts_tel}</p>
        </div>
    ), [])

    return (
        <div className={`module-dealBtnPark ${className}`}>
            <div className="module-dealBtnPark__btns flex col ver hor around">
                <Popover content={content} title="联系人">
                    <button className="module-dealBtnPark__btn module-dealBtnPark__btn--yellow">园区招商引资联络窗口信息</button>
                </Popover>
                <Popover content={content} title="联系人">
                    <button className="module-dealBtnPark__btn module-dealBtnPark__btn--purple">园区招商引资活动参与窗口</button>
                </Popover>
                <Popover content={content} title="联系人">
                    <button className="module-dealBtnPark__btn module-dealBtnPark__btn--blue">园区招商项目意向信息提交</button>
                </Popover>
            </div>
        </div>
    )
}

export default DealBtn;